// ---------- Theme Controller ----------
class ThemeController {
    constructor() {
        this.currentTheme = null;
        this.buttons = document.querySelectorAll('.theme-btn');
        this.html = document.documentElement;
        this.announcer = null;
        this.init();
    }

    init() {
        const saved = safeStorage.get('theme');

        let startTheme;
        if (!saved) {
            // Geen voorkeur opgeslagen → volg systeem
            startTheme = getSystemTheme();
            safeStorage.set('theme', 'system');
        } else if (saved === 'system') {
            // User koos expliciet "system"
            startTheme = getSystemTheme();
        } else {
            // User koos expliciet "light/dark/contrast"
            startTheme = saved;
        }

        this.setTheme(startTheme, false);

        // Events voor knoppen
        this.buttons.forEach(btn => {
            btn.addEventListener('click', e =>
                this.setTheme(e.currentTarget.dataset.theme, true)
            );
        });

        // Volg OS alleen als user "system" koos
        if (window.matchMedia) {
            window.matchMedia('(prefers-color-scheme: dark)')
                .addEventListener('change', () => {
                    if (safeStorage.get('theme') === 'system') {
                        this.setTheme(getSystemTheme(), false);
                    }
                });
        }

        this.announcer = createAnnouncer('theme-announcer');
    }

    setTheme(theme, announce = true) {
        if (theme === this.currentTheme) return;

        // Reset alle classes
        this.html.classList.remove('theme-light', 'theme-dark', 'theme-contrast');

        if (theme === 'system') {
            // Dit pad komt alleen via knop → volgsysteemflow aanzetten
            const systemTheme = getSystemTheme();
            this.html.classList.add(`theme-${systemTheme}`);
            safeStorage.set('theme', 'system');
        } else {
            // Gewoon expliciete keuze
            this.html.classList.add(`theme-${theme}`);
            safeStorage.set('theme', theme);
        }

        this.updateButtonStates(theme);
        this.currentTheme = theme;

        if (announce && this.announcer) {
            const names = {
                light: 'licht thema',
                dark: 'donker thema',
                contrast: 'hoog contrast thema',
                system: 'systeem voorkeur'
            };
            this.announcer.textContent = `Thema gewijzigd naar ${names[theme] || theme}`;
        }
    }

    updateButtonStates(active) {
        this.buttons.forEach(btn =>
            btn.setAttribute('aria-pressed', (btn.dataset.theme === active).toString())
        );
    }
}
